import Swal from 'sweetalert2'; 

export const mostrarAlertaError = (mensaje) => {
    Swal.fire({
        title: 'Atención',
        html: mensaje,
        icon: 'warning',
        showCloseButton: true,
        showCancelButton: false,
        confirmButtonText: 'Aceptar',
        allowOutsideClick: true
    });
};

export const validarAmbitoEjercicio = (datosEjercicio) => {
    const { checkPublico, checkPrivado, tpo_ejercicio, IDOrganismoPublico, NombreEntePublico, NombreEntePrivado } = datosEjercicio;
    let errores = [];
    if (!checkPublico && !checkPrivado) {
        errores.push('• Debe seleccionar al menos un ámbito de ejercicio (Público o Privado).');
    }
    if (checkPublico) {
        if (!tpo_ejercicio) {
            errores.push('• Seleccionó ámbito Público pero no indicó el Nivel de Gobierno.');
        } else {
            // Nacional(6) o Provincial(5)
            if ((parseInt(tpo_ejercicio) === 6 || parseInt(tpo_ejercicio) === 5) && !IDOrganismoPublico) {
                errores.push('• En ámbito Público (Nacional/Provincial), debe seleccionar un Organismo del listado.');
                errores.push('• Si el organismo en el que ejerce la profesión no se encuentra en el listado contáctese con el Sector Matrículas al 0221 – 441 4100.');
            }
            // Municipal(7)
            if (parseInt(tpo_ejercicio) === 7 && (!NombreEntePublico || NombreEntePublico.trim() === '')) {
                errores.push('• En ámbito Público (Municipal), debe ingresar el nombre de la entidad.');
            }
        }
    }
    if (checkPrivado) {
        if (!NombreEntePrivado || NombreEntePrivado.trim() === '') {
            errores.push('• Seleccionó ámbito Privado pero no ingresó el Nombre de la Organización.');
        }
    }
    if (errores.length > 0) {
        return '<div style="text-align: left;">' + errores.join('<br>') + '</div>';
    }
    return null;
};